import { render, staticRenderFns } from "./MoreRestaurantsShiftsChart.vue?vue&type=template&id=14553edc"
import script from "./MoreRestaurantsShiftsChart.vue?vue&type=script&lang=js"
export * from "./MoreRestaurantsShiftsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports